export const BASE_API_URI = 'https://app-api.vitspot.com/';
export const GOOGLE_LOGIN_CLIENT_ID = '662016423773-ceea1kk8m48ml28u56tu4uin06lhsqpd.apps.googleusercontent.com';
